import React from 'react';

const StatRow = ({ label, value, highlight }) => (
  <div className={`flex items-center justify-between py-1.5 border-b border-[rgba(101,141,113,0.2)] last:border-0 ${highlight ? 'bg-[rgba(216,206,179,0.04)] px-1' : ''}`}>
    <span className="text-[10px] uppercase tracking-widest text-[#a9c9b1] font-bold">{label}</span>
    <span className={`text-sm font-black tabular-nums ${highlight ? 'text-[#d8ceb3]' : 'text-white'}`}>{value ?? '--'}</span>
  </div>
);

const DashboardPitchingBatting = ({ teamStats }) => {
  const hitting = teamStats?.stats?.find(s => s.group?.displayName === 'hitting')?.splits?.[0]?.stat;
  const pitching = teamStats?.stats?.find(s => s.group?.displayName === 'pitching')?.splits?.[0]?.stat;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
        <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
          <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Team Batting</span>
        </div>
        <div className="p-3">
          {hitting ? (
            <>
              <StatRow label="AVG" value={hitting.avg} highlight />
              <StatRow label="OBP" value={hitting.obp} />
              <StatRow label="SLG" value={hitting.slg} />
              <StatRow label="OPS" value={hitting.ops} highlight />
              <StatRow label="Home Runs" value={hitting.homeRuns} />
              <StatRow label="RBI" value={hitting.rbi} />
              <StatRow label="Stolen Bases" value={hitting.stolenBases} />
              <StatRow label="Strikeouts" value={hitting.strikeOuts} />
            </>
          ) : <p className="text-[#658d71] text-xs text-center py-6 uppercase tracking-widest">No data</p>}
        </div>
      </div>
      <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
        <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
          <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Team Pitching</span>
        </div>
        <div className="p-3">
          {pitching ? (
            <>
              <StatRow label="ERA" value={pitching.era} highlight />
              <StatRow label="WHIP" value={pitching.whip} highlight />
              <StatRow label="Strikeouts" value={pitching.strikeOuts} />
              <StatRow label="Walks" value={pitching.baseOnBalls} />
              <StatRow label="Saves" value={pitching.saves} />
              <StatRow label="Innings Pitched" value={pitching.inningsPitched} />
              <StatRow label="HR Allowed" value={pitching.homeRuns} />
              <StatRow label="Opp. AVG" value={pitching.avg} />
            </>
          ) : <p className="text-[#658d71] text-xs text-center py-6 uppercase tracking-widest">No data</p>}
        </div>
      </div>
    </div>
  );
};

export default DashboardPitchingBatting;